// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/carousel/carousel.scss
// module id = 518
// module chunks = 0